import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { TransactionItems } from '@/features/transaction_items/TransactionItems';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';

const TransactionItemsPage = () => {
  const context = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={context}
        domain='ap-frontend-custom-transaction-one'
      >
        <OpenFeatureProvider
          pollInterval={-1}
          context={context}
          domain='ap-frontend-custom-transaction-two'
        >
          <TransactionItems />
        </OpenFeatureProvider>
      </OpenFeatureProvider>
    </Wrapper>
  );
};
export default TransactionItemsPage;
